<div class="summary" *ngIf="cartDetail">
  <h2 class="summary__title">{{ "cart_summary.title" | translate }}</h2>
  <div class="summary__row">
    <span class="row__label">{{
      "cart_summary.total_products" | translate
    }}</span>
    <span *ngIf="!(isPriceHidden$ | async)" classs="row_value">{{
      cartDetail.totalPrice | localizedCurrency
    }}</span>
  </div>
  <div class="summary__row">
    <span class="row__label">{{
      "cart_summary.total_pallets" | translate
    }}</span>
    <span *ngIf="!(isPriceHidden$ | async)" classs="row_value">{{
      cartDetail.palletsPrice | localizedDecimal
    }}</span>
  </div>
  <button
    customButton
    size="large"
    [disabled]="cartDetail.lines.length <= 0"
    expand="full"
    (click)="goToCheckout()"
  >
    {{ "cart_summary.checkout_order" | translate }}
  </button>
</div>
